<template>
  <div class="login-page">
    <!-- <div class="dfe mr100 mt20">
        <el-button :class="{active:$i18n.locale == 'en'}" @click="ENGCheck('en')">ENG</el-button>
        <el-button :class="{active:$i18n.locale == 'zh'}" @click="ENGCheck('zh')">中文</el-button>
    </div> -->
    <img class="image" :src="loginImage"/>
    <!-- 扫码登录 -->
    <!-- "value=value.replace(/[^\w\.\/]/ig,'' -->
    <!-- <div class="input-box" v-if="loginStatus === 'code'">
        <div class="box-title">账户登录</div>
        <el-input @keyup.native="phone = phone.replace(/[^\w\.\/]/ig,'')" class="row input" v-model="phone" placeholder="请输入手机号"></el-input>
        <div class="row">
            <el-input   class="short-input" v-model="pictureVerificationCode" placeholder="请输入图片验证码"></el-input>
            <img class="verification-image" title="点击更换" :src="verificationImageUrl" @click="refreshVerificationImageUrl"/>
        </div>
        <div class="row">
            <el-input class="short-input" v-model="phoneVerificationCode" placeholder="请输入短信验证码"></el-input>
            <el-button class="short-btn" type="primary" @click="sendMessageCode" :disabled="!captchaBtnVisible">{{countdownPoint}}</el-button>
        </div>
        <el-button class="full-width" type="primary" @click="onLoginBtnClick">登录</el-button>
        <div class="passWord">
            <el-button type="text" @click="loginStatus='password'">密码登录</el-button>
        </div>
    </div> -->
    <!-- 密码登录 -->
    <div class="password-box input-box" v-if="loginStatus === 'password'">
      <div class="box-title">{{ $t('lang.Sign_in_title') }}</div>
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm">
        <el-form-item prop="accountNo" key="passwordFormuser">
          <el-input @keyup.native="passwordForm.userName = passwordForm.userName.replace(/[^\w\.\/]/ig,'')"
                    class="row input" v-model="passwordForm.userName" :placeholder="$t('lang.Please_enter_account')"
                    maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="passWord" key="passwordFormpassword">
          <el-input @keyup.enter.native="loginByAccountAndPassWord('passwordForm')" @keyup.native="passwordForm.passWord = passwordForm.passWord.replace(/[^\w\.\/]/ig,'')"
                    class="row input" v-model="passwordForm.passWord" :placeholder="$t('lang.Please_input_a_password')"
                    maxlength="50" type="password"></el-input>
        </el-form-item>
        <!-- <div class="passWord">
            <el-button type="text" @click="forgetStatus">忘记密码</el-button>
        </div> -->
        <div class="btnBox">
          <el-button type="primary" @click="loginByAccountAndPassWord('passwordForm')">{{ $t('lang.login in') }}
          </el-button>
          <el-button type="primary" @click="registerStatus">{{ $t('lang.Register') }}</el-button>
        </div>
      </el-form>

    </div>
    <!-- <div class="input-box" v-if="loginStatus === 'forget'">

    </div> -->
    <!-- 账户注册 -->
    <div class="input-box" v-if="loginStatus === 'register'">
      <div class="box-title">{{ $t('lang.Register_title') }}</div>
      <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
        <el-form-item prop="userName" key="registerFormuserName">
          <el-input v-model="registerForm.userName"
                    @keyup.native="registerForm.userName = registerForm.userName.replace(/[^\w\.\/]/ig,'')"
                    :placeholder="$t('lang.please input your account name')"
                    maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="passWord" key="registerFormuserpassWord">
          <el-input v-model="registerForm.passWord"
                    @keyup.native="registerForm.passWord = registerForm.passWord.replace(/[^\w\.\/]/ig,'')"
                    :placeholder="$t('lang.Please_input_a_password')" type="password"
                    maxlength="16"></el-input>
        </el-form-item>
        <el-form-item prop="rePassWord">
          <el-input v-model="registerForm.rePassWord"
                    :placeholder="$t('lang.Please_input_a_password_again')" type="password"
                    maxlength="16"></el-input>
        </el-form-item>
        <el-form-item prop="verificationCode" class="row">
          <el-input class="short-input" v-model="registerForm.verificationCode"
                    :placeholder="$t('lang.Please-enter-verification-code')"
                    maxlength="4"></el-input>
          <img class="verification-image " :title="$t('clickChange')" :src="verificationImageUrl"
               @click="securityImageCode"/>
        </el-form-item>
        <div class="confirmBtnBox mt20">
          <el-button type="primary" @click="UserAuthorizationRegister('registerForm')">{{ $t('lang.Register_title') }}
          </el-button>
        </div>
        <div class="passWord">
          <el-button type="text" @click="passWordStatus">{{ $t('lang.Existing-account') }}</el-button>
        </div>
      </el-form>
    </div>
    <!-- <div class="footer" v-if="hrefStatus == 'HL'">
        <span>版权所有2021©天津海狸新能源科技有限公司</span>&nbsp;
        <a href="https://beian.miit.gov.cn" target="_blank">津ICP备20004979号-2</a>
    </div>
    <div class="footer" v-if="hrefStatus == 'HL'">
        <span>版权所有2021©天津海狸新能源科技有限公司</span>&nbsp;
        <a href="https://beian.miit.gov.cn" target="_blank">津ICP备20004979号-2</a>
    </div> -->
  </div>
</template>

<script>
import {securityImageCode, UserAuthorizationRegister, loginByAccountAndPassWord, chargePassWord} from '../api/login.js'
import Utils from '../utils/utils'
import loginImage from '../assets/images/hsem-login.png'

export default {
  name: 'loginPage',
  data() {
    return {
      // hrefStatus:'',
      loginStatus: "password",
      enFlag: true,

      // 密码登录
      passwordRules: {
        userName: {required: true, message: this.$t('lang.Please_enter_account'), trigger: 'blur'},
        passWord: {required: true, message: this.$t('lang.Please_input_a_password'), trigger: 'blur'},
      },
      passwordForm: {
        userName: '',
        passWord: '',
        appType: 11,
        loginType: 6
      },
      // 注册
      registerForm: {
        userName: '',
        passWord: '',
        rePassWord: '',
        verificationCode: '',
        appType: 11,
        loginType: 6
      },
      registerRules: {
        userName: {required: true, message: this.$t('lang.Please_enter_account'), trigger: 'blur'},
        passWord: {required: true, message: this.$t('lang.Please_input_a_password'), trigger: 'blur'},
        rePassWord: {required: true, message: this.$t('lang.Please input new password'), trigger: 'blur'},
        verificationCode: {required: true, message: this.$t('lang.Please-enter-verification-code'), trigger: 'blur'},
      },
      flag: true,
      phone: "",
      pictureVerificationCode: "",
      phoneVerificationCode: "",
      captchaBtnVisible: true,
      countdown: 60,
      verificationImageUrl: "",
      // countdownPoint:"获取验证码",
      loginImage: loginImage
    }
  },
  mounted() {
    localStorage.removeItem('userName');
    // localStorage.setItem('language','zh');

    // this.getUserInfo();
    this.securityImageCode();
    // const hrefStr = location.href;
    // if(hrefStr.includes('38690000-id.entry.go-grid.com')){
    //     this.hrefStatus = 'ZR'
    // }else{
    //     this.hrefStatus = 'HL'
    // }
    // console.log(this.hrefStatus,'hrefStatus');
  },
  // computed:{
  //     enType(){
  //         console.log(localStorage.getItem('language'),'11111111111');
  //         return localStorage.getItem('language') == 'en' ? 'primary' : '';
  //     },
  //     zhType(){
  //         return localStorage.getItem('language') == 'zh' ? 'primary' : '';
  //     }
  // },
  methods: {
    // 切换语言
    ENGCheck(val) {
      this.$i18n.locale = val;
      this.enFlag = !this.enFlag;
    },
    // 密码登录状态
    passWordStatus() {
      this.loginStatus = 'password';
    },
    // 忘记密码状态
    forgetStatus() {
      this.loginStatus = 'forget';
    },
    // 注册状态
    registerStatus() {
      this.loginStatus = 'register';
    },
    // 注册按钮
    async UserAuthorizationRegister(formName) {
      const self = this;
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return;
        }
        if (this.registerForm.passWord.length < 6) {
          this.$message.error(this.$t('lang.Password at least 6 characters'));
          return;
        }
        if (this.registerForm.passWord !== this.registerForm.rePassWord) {
          this.$message.error(this.$t('lang.The two passwords do not match'));
          return;
        }
        const params = {...this.registerForm};
        params.passWord = this.$md5(params.passWord);
        params.rePassWord = this.$md5(params.rePassWord);
        if (this.flag) {
          this.flag = false;
          try {
            const res = await UserAuthorizationRegister(params);
            if (res.result === 1) {
              this.$message.success(this.$t('lang.Successful'));
              this.loginStatus = "password";
            }
            if (res.result === 0) {
              this.securityImageCode();//获取验证码
            }
          } catch (e) {
          }
          setTimeout(() => {
            this.flag = true;
          }, 1000);
        }

      });
    },


    // 密码登录按钮
    async loginByAccountAndPassWord(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return;
        }
        try {
          const params = {...this.passwordForm};
          params.passWord = this.$md5(params.passWord);
          const res = await loginByAccountAndPassWord(params);
          if (res.result === 0) {
            return;
          }
          localStorage.setItem('userName', params.userName);
          // this.$store.commit('setUserName',{userName:params.userName});
          this.$router.push('/managePage/batterySwapMgmt');
        } catch (e) {
          // this.$message.error(e)
        }

      })
      // this.$refs[formName].validate(async (valid) => {
      //   if (valid) {
      //         try{
      //             const params = {};
      //             const res = await send(params);
      //             console.log(res,'登录res');
      //         }catch(e){

      //         }
      //   } else {
      //     return false;
      //   }
      // });
    },
    // 获取验证码
    securityImageCode() {
      let self = this;
      this.$http.post('/securityImageCode?' + Math.random()).then(function (response) {
        let data = response.data;
        if (!data) {
          self.$message({
            type: "error",
            message: self.$t('lang.Failed to get image captcha'),
            center: true
          });
          return;
        }
        self.verificationImageUrl = "data:image/png;base64," + data;
      }).catch(function (response) {
        console.log(response);
      });
    },
    // 发送验证码
    // sendMessageCode(){
    //     if(!this.phone){
    //         this.$message({
    //             type:"error",
    //             message:'请填写您的手机号码!',
    //             center: true
    //         });
    //         return;
    //     }
    //     if(this.phone.length!=11){
    //         this.$message({
    //             type:"error",
    //             message:'手机号码格式不正确!',
    //             center: true
    //         });
    //         return;
    //     }
    //     if(!this.pictureVerificationCode){
    //         this.$message({
    //             type:"error",
    //             message:'请填写图片验证码!',
    //             center: true
    //         });
    //         return;
    //     }
    //     let params = {
    //         phone:this.phone,
    //         pictureVerificationCode:this.pictureVerificationCode,
    //         mgmtType: 0,
    //     };
    //     let self = this;
    //     this.$http.post('/managementPlatform/sendMessageCode',this.$qs.stringify(params), {headers: {mgmtType: 0}}).then(function(response){
    //         let res = response.data;
    //         if (!res || !res.result) {
    //             self.$message({
    //                 type:"error",
    //                 message:res.message,
    //                 center: true
    //             });
    //             return;
    //         }
    //     }).catch(function(response){
    //         console.log(response);
    //     });
    // },
    // 发送短信
    // verificationCountDown(){
    //     this.captchaBtnVisible = false;
    //     let self = this;
    //     function countDown(){
    //         if(self.countdown == 0){
    //             self.captchaBtnVisible = true;
    //             self.countdown = 60;
    //             self.countdownPoint="重新发送";
    //             self.refreshVerificationImageUrl();
    //         }else{
    //             self.countdownPoint = "重新发送(" + self.countdown + ")";
    //             self.countdown--;
    //             self.captchaTimer = setTimeout(countDown, 1000);
    //         }
    //     }
    //     countDown();
    // },
    // refreshVerificationImageUrl(){
    //     this.securityImageCode();
    // },
    // 扫码登录按钮
    // onLoginBtnClick(){
    //     // this.refreshVerificationImageUrl();//换验证码
    //     this.userLoginByPhone();
    // },
    // 短信登录
    // userLoginByPhone(){
    //     if(!this.phoneVerificationCode){
    //         this.$message({
    //             type:"error",
    //             message:"请输入短信验证码",
    //             center: true
    //         });
    //         return;
    //     }
    //     let self = this;
    //     let params = {
    //         phoneVerificationCode:this.phoneVerificationCode,
    //     };
    //     this.$http.post('/managementPlatform/userLoginByPhone',this.$qs.stringify(params), {headers: {mgmtType: 0}}).then(function(response){
    //         let res = response.data;
    //         if (!res || !res.result) {
    //             self.$message({
    //                 type:"error",
    //                 message:res.message,
    //                 center: true
    //             });
    //             return;
    //         }
    //         self.getUserInfo();
    //     }).catch(function(response){
    //         console.log(response);
    //     });
    // },
    getUserInfo() {
      let self = this;
      this.$http.post('/client/sms/userInformation').then(function (response) {
        let res = response.data;
        if (res.mdata.userInformationDto) {
          self.$store.dispatch('SET_CURRENT_USER', res.mdata.userInformationDto.loginPhone);
          self.$router.replace('/managePage');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-30%);
  height: 30px;
  line-height: 30px;

  span {
    display: inline-block;
    margin-bottom: -5px;
  }

  a {
    position: absolute;
    width: 180px;
    top: 0px;
    left: 270px;
    color: blue;
    font-weight: bold;
  }
}

.mt20 {
  margin-top: 20px;
}

// 密码登录
.confirmBtnBox {
  display: flex;
  justify-content: center;
  // align-item:center;
  width: 100%;

  .el-button {
    width: 150px;
  }
}

.btnBox {
  display: flex;
  width: 100%;

  .el-button {
    width: 50%;

  }
}

.passWord {
  display: flex;
  justify-content: flex-end;
}

//
.login-page {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .image {
    display: inline-block;
    width: 50vw;
    //height: 600px;
    //margin-left: 200px;
    margin-bottom: 100px;
  }

  .input-box {
    //position: absolute;
    //top: 200px;
    //right: 250px;
    width: 333px;
    height: 442px;
    box-shadow: 0px 3px 15px 0px rgba(170, 170, 170, 0.32);
    border-radius: 7px;
    padding: 22px;
    box-sizing: border-box;
    margin-bottom: 25px;

    .box-title {
      font-size: 19px;
      color: #000;
      padding-bottom: 25px;
    }

    .row {
      height: 32px;
      margin-bottom: 15px;
      font-size: 14px;
      line-height: 16px;

      .short-input {
        width: 180px;
        margin-right: 10px;
        vertical-align: middle;
      }

      .verification-image {
        width: 92px;
        height: 32px;
        vertical-align: middle;
      }

      .short-btn {
        vertical-align: middle;
        width: 94px;
      }

      .check-box {
        padding: 5px 0;
      }

      .text-btn {
        float: right;
      }
    }
  }

  .full-width {
    width: 100%;
  }
}

.active {
  background: #4CB132;
  color: #fff;
  border: 1px solid #4CB132;
}

</style>



// WEBPACK FOOTER //
// src/components/loginPage.vue